import { makeActionCreator } from "../../utils";

export const ORDER_CALENDAR_CHANGED = "ORDERS.ORDER_CALENDAR_CHANGED";

export const orderCalendarChanged = makeActionCreator(ORDER_CALENDAR_CHANGED, "payload");
